import { useQuery } from "@tanstack/react-query";
import { Select } from "antd";
import { useAuthenticatedRequest } from "hooks/useRequests";
import { CardTitleInQA } from "models/cardIngestion";
import { CardBatch } from "models/cards";
import { KeyboardEvent } from "react";
import { CancelEdit, SaveEdit } from "util/editableTable";

interface PackageBatchSelectorProps {
    row: CardTitleInQA,
    save: SaveEdit<CardTitleInQA>,
    cancel: CancelEdit,
}

export const usePackageBatches = (packageId: string | null) => {
    const fetch = useAuthenticatedRequest<CardBatch[]>({
        method: "get",
        url: `/packages/${packageId}/batches`
    });

    return useQuery(["packages", packageId, "batches"], fetch, {
        enabled: !!packageId
    });
}

const PackageBatchSelector = ({ row, save, cancel }: PackageBatchSelectorProps) => {
    const { data = [], isLoading } = usePackageBatches(row.packageId);

    const onKeyDown = async (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Escape") {
            cancel();
        }
    };

    const saveChanges = async (newBatch: string) => {
        await save({ batch: newBatch });
    }

    return <Select
        loading={isLoading}
        disabled={isLoading}
        onKeyDown={onKeyDown}
        options={data.map(b => ({
            label: b.number,
            value: b.number,
        }))}
        onChange={saveChanges}
        defaultValue={row.batch}
    />
}

export default PackageBatchSelector;